import Sentry from '../../Infrastructure/Sentry';
import InMemory from '../../Infrastructure/InMemory';

const ErrorTrackerServiceProvider = () => {
    const provider = mountProvider();
    verifyInterface(provider);

    return provider;
}

const mountProvider = () => {
    /**
     * Disable reporting for production due to rate limitations
     */
    return InMemory();


    if (process.env.NODE_ENV !== 'production') {
        return InMemory();
    }

    return Sentry('https://bfb19f785a3c4acb9657296bc828d187@o29928.ingest.sentry.io/1381066');
}

const verifyInterface = (concreteImplementation) => {
    const IErrorTracker = [
        'setUser',
        'setAccount',
        'setExtraContext',
        'captureException',
        'captureMessage',
    ];

    const implementationProperties = Object.keys(concreteImplementation);

    const hasAllProps = IErrorTracker.every((prop) => {
        return implementationProperties.includes(prop);
    });

    if (!hasAllProps) {
        const missingProps = IErrorTracker.filter(function(prop) {
            return !implementationProperties.includes(prop);
        });

        throw new Error(`ErrorTracker has missing properties: (${missingProps.join(', ')})`)
    }
}

export default ErrorTrackerServiceProvider;
